import CreateTagContainer from "../../../../Component/Application/Tags/CreateTag/CreateTag";

const AddTag = () => {
  return (
    <div className="page-body">
      <CreateTagContainer />
    </div>
  );
};

export default AddTag;
